import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import TopNav from "@/components/TopNav";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import AddExpense from "@/pages/AddExpense";
import ExpensesList from "@/pages/ExpensesList";
import ExpenseDetail from "@/pages/ExpenseDetail";
import Approvals from "@/pages/Approvals";
import Profile from "@/pages/Profile";
import Team from "@/pages/Team";

function Shell() {
  return (
    <div className="min-h-screen bg-zinc-50">
      <TopNav />
      <Outlet />
    </div>
  );
}

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return <Navigate to={user ? "/dashboard" : "/login"} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route
            element={
              <ProtectedRoute>
                <Shell />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/add" element={<AddExpense />} />
            <Route path="/expenses" element={<ExpensesList />} />
            <Route path="/expense/:id" element={<ExpenseDetail />} />
            <Route path="/profile" element={<Profile />} />
            <Route
              path="/team"
              element={
                <ProtectedRoute managerOnly>
                  <Team />
                </ProtectedRoute>
              }
            />
            <Route
              path="/approvals"
              element={
                <ProtectedRoute managerOnly>
                  <Approvals />
                </ProtectedRoute>
              }
            />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
